export function getWallCOBB(id: string) {
  return `COBB_${id}`
}
